import { Injectable } from '@angular/core';
import { Router, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CommonService } from '..//services/common.service';
import { environment } from "./../../environments/environment";
import { Observable } from 'rxjs';

@Injectable()
export class AdminguardService implements CanActivateChild {

  constructor(private router: Router,
    private _commonService: CommonService) { }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    // this will be passed from the route config
    // on the data property
    const expectedRole: string[] = route.data.expectedRole;
    //console.log(expectedRole);
    let accessLevel = this._commonService.getAccessLevel(environment.accessGroupKey);
    if (accessLevel && expectedRole.indexOf(accessLevel.AccessKey) >= 0) {
      return true;
    }
    else {
      console.log('User is not an Admin, only WIP admins can access this page.');
    }
    //not Authorized user, redirect to home page
    this.router.navigate(['/home']);
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/adminguard.service.ts